import { useFormik } from "formik";
import React from "react";

import {
  Button,
  Checkbox,
  Col,
  Divider,
  Form,
  Input,
  message,
  Modal,
  Row,
  Space,
  Table,
  Tabs,
  Typography,
} from "antd";
import Text from "antd/lib/typography/Text";
import { useDispatch, useSelector } from "react-redux";
import {
  companySetting,
  DeleteTripsField,
  AddTripsField,
  deleteTripsField,
  getTripsField,
  UpdateCompanyTrips,
  updateCompanyTrips,
  UpdateTripsField,
  updateTripsField,
} from "../../../../actions/companySettings";
import AddNewIcon from "../../../../assets/icons/add_new_white.png";
import DeleteIcon from "../../../../assets/icons/delete.png";
import EditIcon from "../../../../assets/icons/edit.png";
import { hasAccess, objectToFormData } from "../../../../utils";
import PageHeader from "../../../PageHeader";
import "./../../styles/setting.css";
import "./../Custom.css";
import AddExpenseField from "./AddTripsField";

const { TabPane } = Tabs;
const { Title } = Typography;

const columns = [
  {
    title: "Field",
    dataIndex: "column_name",
    key: "column_name",
  },
  {
    title: "Column Type",
    dataIndex: "column_type",
    key: "column_type",
  },
];

message.config({
  maxCount: 3,
});

const Trips = () => {
  // const [activeTab, setActiveTab] = React.useState('profile');
  const dispatch = useDispatch();

  const [isModalVisible, setIsModalVisible] = React.useState(false);
  const [modalType, setIsModalType] = React.useState("center");
  const [selectedId, setSelectedId] = React.useState("");
  const [tripsFields, setTripsFields] = React.useState([]);
  const [editMode, setEditMode] = React.useState(false);

  // const [companyValues, setCompanyValues] = React.useState({});

  const formik = useFormik({
    initialValues: {
      trip_prefix: "",
    },
    onSubmit: (values) => {
      const payload = {};
      [
        "trip_prefix",
        "trip_starts_with",
        "trip_amount_comments_pdf",
        "trip_amount_history_pdf",
        "trip_amount_mandatory",
        "trip_amount_receive_copy",
        "trip_amount_receive_email",
        "trip_amount_reminder",
        "trip_amount_reminder_days",
        "trip_emp_details_pdf",
        "trip_include_logo_pdf",
      ].forEach((item) => {
        payload[item] = values[item];
      });

      if (!payload.trip_amount_reminder_days) {
        payload.trip_amount_reminder_days = 0;
      }

      if (!payload.trip_amount_receive_email) {
        payload.trip_amount_receive_email = 0;
      }

      // ['trip_amount_reminder_days', 'trip_amount_receive_email'].includes(payload)

      dispatch(updateCompanyTrips(objectToFormData({ ...payload })));
    },
  });

  const companySettingResponse = useSelector(
    (state) => state.companySetting.companySetting || {},
  );
  const updateCompanySettingResponse = useSelector(
    (state) => state.companySetting.updateCompanySetting || {},
  );
  const tripsFieldResponse = useSelector(
    (state) => state.companySetting.getTripsField || {},
  );
  const deleteTripsFieldResponse = useSelector(
    (state) => state.companySetting.deleteTripsField || {},
  );
  const addTripsFieldResponse = useSelector(
    (state) => state.companySetting.addTripsField || {},
  );
  const updateTripsFieldResponse = useSelector(
    (state) => state.companySetting.updateTripsField || {},
  );
  const updateCompanyTripsResponse = useSelector(
    (state) => state.companySetting.updateCompanyTrips || {},
  );
  const setTab = () => {};

  React.useEffect(() => {
    dispatch(companySetting({ show: "id" }));
    dispatch(getTripsField({}));
    // setIsModalVisible(false,);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    const { data: { message: res_message = "", status = false } = {} } =
      updateCompanyTripsResponse;
    if (status) {
      dispatch(companySetting({}));
      handleSubmit();
      dispatch({
        type: UpdateCompanyTrips.RESET,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateCompanyTripsResponse]);

  const { data: { response: { company_setting = {} } = {} } = {} } =
    companySettingResponse;

  React.useEffect(() => {
    formik.resetForm();
    const { data: { response: { company_setting = {} } = {} } = {} } =
      companySettingResponse;
    // setCompanyValues({...company_setting});
    formik.setValues({
      trip_prefix: company_setting.trip_prefix,
      trip_starts_with: company_setting.trip_starts_with,
      trip_amount_history_pdf: company_setting.trip_amount_history_pdf,
      trip_amount_comments_pdf: company_setting.trip_amount_comments_pdf,
      trip_amount_mandatory: company_setting.trip_amount_mandatory,
      trip_amount_receive_copy: company_setting.trip_amount_receive_copy,
      trip_amount_receive_email: company_setting.trip_amount_receive_email,
      trip_amount_reminder: company_setting.trip_amount_reminder,
      trip_amount_reminder_days: company_setting.trip_amount_reminder_days,
      trip_emp_details_pdf: company_setting.trip_emp_details_pdf,
      trip_include_logo_pdf: company_setting.trip_include_logo_pdf,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companySettingResponse]);

  React.useEffect(() => {
    const {
      data: { message: res_message = "", status = "", errors = "" } = {},
    } = updateCompanySettingResponse;
    if (status) {
      dispatch({
        type: UpdateCompanyTrips.RESET,
      });
    } else if (status === false && errors) {
      dispatch({
        type: UpdateCompanyTrips.RESET,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateCompanySettingResponse]);

  React.useEffect(() => {
    const {
      data: { message: res_message = "", status = "", errors = "" } = {},
    } = updateTripsFieldResponse;
    if (status) {
      setIsModalVisible(false);
      dispatch(getTripsField({}));
      dispatch({
        type: UpdateTripsField.RESET,
      });
    } else if (status === false && errors) {
      dispatch({
        type: UpdateTripsField.RESET,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateTripsFieldResponse]);

  React.useEffect(() => {
    const {
      data: { message: res_message = "", status = "", errors = "" } = {},
    } = deleteTripsFieldResponse;
    if (status) {
      setIsModalVisible(false);
      dispatch(getTripsField({}));
      dispatch({
        type: DeleteTripsField.RESET,
      });
    } else if (status === false && errors) {
      dispatch({
        type: DeleteTripsField.RESET,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deleteTripsFieldResponse]);

  React.useEffect(() => {
    const {
      data: { message: res_message = "", status = "", errors = "" } = {},
    } = addTripsFieldResponse;
    if (status) {
      setIsModalVisible(false);
      dispatch(getTripsField({}));
      dispatch({
        type: AddTripsField.RESET,
      });
    } else if (status === false && errors) {
      dispatch({
        type: AddTripsField.RESET,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addTripsFieldResponse]);

  React.useEffect(() => {
    const { data: { response: { fields = [] } = {}, status = false } = {} } =
      tripsFieldResponse;
    if (status) {
      setTripsFields(fields);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tripsFieldResponse]);

  const tableAction = [
    {
      title: "Mandatory",
      dataIndex: "is_required",
      key: "is_required",
      render: (status, record) => (
        <Checkbox
          key={record.id}
          disabled={!hasAccess("trips_settings", "write")}
          onChange={(e) =>
            dispatch(
              updateTripsField(
                objectToFormData({
                  ...record,
                  is_required: e.target.checked,
                }),
              ),
            )
          }
          checked={status}
        ></Checkbox>
      ),
    },
    // {
    //   title: "Show in PDF",
    //   dataIndex: "view_in_pdf",
    //   key: "view_in_pdf",
    //   render: (status, record) => (
    //     <Checkbox
    //       key={record.id}
    //       disabled={!hasAccess("trips_settings", "write")}
    //       onChange={(e) =>
    //         dispatch(
    //           updateTripsField(
    //             objectToFormData({
    //               ...record,
    //               view_in_pdf: e.target.checked,
    //             })
    //           )
    //         )
    //       }
    //       checked={status}
    //     ></Checkbox>
    //   ),
    // },
    {
      title: "Enable",
      name: "enable",
      dataIndex: "is_enable",
      key: "is_enable",
      render: (status, record) => (
        <Checkbox
          key={record.id}
          disabled={!hasAccess("trips_settings", "write")}
          onChange={(e) =>
            dispatch(
              updateTripsField(
                objectToFormData({ ...record, is_enable: e.target.checked }),
              ),
            )
          }
          checked={status}
        ></Checkbox>
      ),
    },
    {
      title: "Actions",
      key: "action",
      render: (text, record) => (
        <Space key={record.id} size="middle">
          <button
            disabled={!hasAccess("trips_settings", "write")}
            onClick={() => showEditModal(record.id)}
          >
            <img src={EditIcon} alt={"logo"} className="action-logo" />
          </button>
          <button
            disabled={!hasAccess("trips_settings", "write")}
            onClick={() => showDeleteModal(record.id)}
          >
            <img src={DeleteIcon} alt={"logo"} className="action-logo" />
          </button>
        </Space>
      ),
    },
  ];

  const showModal = () => {
    setSelectedId("");
    setIsModalVisible(true);
    setIsModalType("right");
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const showDeleteModal = (id) => {
    setSelectedId(id);
    setIsModalVisible(true);
    setIsModalType("center");
  };

  const showEditModal = (id) => {
    setSelectedId(id);
    setIsModalVisible(true);
    setIsModalType("right");
  };

  const handleEdit = () => {
    setEditMode(true);
  };

  const handleSubmit = () => {
    setEditMode(false);
  };

  const renderDeleteOption = () => {
    return (
      <>
        <Text>Are you sure you want to delete this field?</Text>
        <br />
        <Button
          key="1"
          className="formButton mt1"
          onClick={() =>
            dispatch(deleteTripsField(objectToFormData({ id: selectedId })))
          }
        >
          Delete
        </Button>
        <Button
          key="2"
          className="cancelButton ml1 mt1"
          onClick={() => handleCancel()}
        >
          Cancel
        </Button>
      </>
    );
  };

  return (
    <>
      <Modal
        title={
          modalType === "center" ? (
            <>
              <img src={DeleteIcon} alt={"logo"} className="action-logo" />{" "}
              Delete Field
            </>
          ) : (
            <Title level={4}>
              {selectedId ? "Edit Fields" : "Add Fields"} &nbsp;
              <span className="text-small">Enter details and submit</span>
            </Title>
          )
        }
        visible={isModalVisible}
        onCancel={handleCancel}
        footer={[]}
        className={
          modalType === "center"
            ? "center-aligned-modal"
            : "right-alinged-modal-small"
        }
      >
        {modalType === "center" ? (
          renderDeleteOption()
        ) : (
          <AddExpenseField id={selectedId} handleCancel={handleCancel} />
        )}
      </Modal>
      <div className="heading-div">
        <PageHeader
          title={`Trips`}
          navigation={{
            Home: "/dashboard/",

            Customisation: "/setting/customisation/",
            Trips: null,
          }}
        />
      </div>
      <Tabs onChange={setTab} type="card" size="large" className="custom-tabs">
        <TabPane tab="Preferences" key="preferences">
          <div className="tabContentWrapper">
            <Title level={5}>Auto-generate Trip ID</Title>
            <Divider />
            <Form
              layout="vertical"
              className="custom-form"
              onFinish={formik.handleSubmit}
              // validateMessages={validateMessages1}
            >
              <Row>
                <Col span={8}>
                  <Form.Item label="Prefix">
                    <Input
                      placeholder=""
                      value={formik.values.trip_prefix}
                      onChange={formik.handleChange}
                      name="trip_prefix"
                      disabled={!editMode || company_setting.trip_prefix}

                      // disabled={/*form.getFieldValue("trip_prefix")||*/
                      //   company_setting.trip_prefix
                      // }
                    />
                  </Form.Item>
                </Col>
                <Col span={8} className="ml1">
                  <Form.Item
                    label="Start with"
                    rules={[{ required: true, message: "Please input value!" }]}
                  >
                    <Input
                      placeholder=""
                      name="trip_starts_with"
                      //  onChange={formik.handleChange}
                      onChange={(e) => {
                        if (Number.isNaN(Number(e.target.value))) {
                          return;
                        }
                        formik.setFieldValue(
                          "trip_starts_with",
                          e.target.value,
                        );
                      }}
                      value={formik.values.trip_starts_with}
                      disabled={!editMode || company_setting.trip_starts_with}

                      //  disabled={company_setting.trip_starts_with}
                    />
                  </Form.Item>
                </Col>
              </Row>

              <Title level={5} className="customTitle">
                Notifications
              </Title>
              <Divider />
              <Row>
                <Col span={24}>
                  <Form.Item
                    valuePropName="checked"
                    style={{ marginBottom: "0px" }}
                  >
                    <Checkbox
                      checked={formik.values.trip_amount_reminder}
                      name="trip_amount_reminder"
                      disabled={!editMode}
                      onChange={(e) => {
                        formik.setFieldValue(
                          "trip_amount_reminder",
                          e.target.checked,
                        );
                      }}
                    >
                      <span className="flexDisplay">
                        Reminder alert to employees if the trip's is pending for
                        more than &nbsp;
                        <Form.Item className="shortNumberInput">
                          <Input
                            className="shortInput"
                            name="trip_amount_reminder_days"
                            disabled={!editMode}
                            onChange={(e) => {
                              if (Number.isNaN(Number(e.target.value))) {
                                return;
                              }
                              formik.setFieldValue(
                                "trip_amount_reminder_days",
                                e.target.value,
                              );
                            }}
                            value={formik.values.trip_amount_reminder_days}
                          />
                        </Form.Item>{" "}
                        &nbsp;days for submission
                      </span>
                    </Checkbox>
                  </Form.Item>
                </Col>
              </Row>

              {/* <Title level={5} className="customTitle">
                Settings
              </Title>
              <Divider />
              <Row>
                <Col span={24}>
                  <Form.Item
                    name="trip_amount_mandatory"
                    valuePropName="checked"
                  >
                    <Checkbox>
                      Apply advance amount mandatory in expense report
                    </Checkbox>
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item
                    name="trip_amount_receive_copy"
                    valuePropName="checked"
                  >
                    <Checkbox>Receive a copy of the Advance Amount</Checkbox>
                  </Form.Item>
                </Col>
                <Col span={9}>
                  <Form.Item name="trip_amount_receive_email">
                    <Input placeholder="" />
                  </Form.Item>
                </Col>
              </Row> */}
              {!editMode && hasAccess("trips_settings", "write") && (
                <Button className="formButton mt3" onClick={() => handleEdit()}>
                  Edit
                </Button>
              )}
              {editMode && (
                <Button
                  key="5"
                  className="formButton mt3"
                  htmlType="submit"
                  disabled={updateCompanyTripsResponse?.loading}
                >
                  Save
                </Button>
              )}
              {/* <Button key="6" className="cancelButton ml1 mt3" onClick={() => history.push(RouteConstants.SETTING_USERS)}></Button> */}
            </Form>
          </div>
        </TabPane>
        <TabPane tab="Fields" key="fields">
          <div className="tabContentWrapper">
            {hasAccess("trips_settings", "write") && (
              <Button onClick={showModal} className="mb1 addNew">
                <img src={AddNewIcon} alt={"logo"} className="addNew-logo" />
                New Field
              </Button>
            )}
            <Table
              rowKey="id"
              columns={[...columns, ...tableAction]}
              dataSource={tripsFields}
              className="settingsTable"
            />
          </div>
        </TabPane>
      </Tabs>
    </>
  );
};

export default Trips;
